/* 
 * Export component file to be used on project
*/

import { Typography } from './Typography.js';
export default Typography;
